import * as React from "react";
import { EmailDetails } from "../Shared/EmailDetails";
import { WithTranslation, withTranslation } from "react-i18next";
import { I18N_NS } from "Config/i18n";
import { Modal } from "Components/General/Modal/GenericModal";
import { observer } from "mobx-react";
import { emailLinkedViewStore } from "../Stores/EmailLinkedViewStore";

interface ViewLinkedMailModalProps extends WithTranslation {}

export const ViewLinkedMailModal = withTranslation(I18N_NS.PROJECT)(
  observer(
    class extends React.Component<ViewLinkedMailModalProps, {}> {
      render() {
        return (
          <Modal
            open={emailLinkedViewStore.showLinkedMailVisible}
            footer={null}
            width={`100%`}
            destroyOnHidden={true}
            style={{ maxWidth: 1200 }}
            onCancel={() => emailLinkedViewStore.showLinkedMail(null)}
            styles={{ body: { paddingTop: 50 } }}
          >
            {emailLinkedViewStore.showLinkedMailVisible && (
              <EmailDetails
                {...this.props}
                projectSpecific={false}
                type="LINKED"
                primaryActions={[]}
                updateEmailData={() => null}
                emailId={emailLinkedViewStore.showLinkedMailId}
              />
            )}
          </Modal>
        );
      }
    }
  )
);
